import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  AxelorSessionHeaderContributor,
  HTTP_HEADER_CONTRIBUTORS,
} from '@core/http/http-header-contributor';
import { apiErrorInterceptor } from '@core/http/interceptors/api-error.interceptor';
import { csrfTokenInterceptor } from '@core/http/interceptors/csrf-token.interceptor';
import { httpHeadersInterceptor } from '@core/http/interceptors/http-headers.interceptor';
import { machineInfoInterceptor } from '@core/http/interceptors/machine-info.interceptor';
import { requestTimeoutInterceptor } from '@core/http/interceptors/request-timeout.interceptor';
import { testUiMockApiInterceptor } from '@core/http/interceptors/test-ui-mock-api.interceptor';

export function provideCoreHttp(): EnvironmentProviders {
  return makeEnvironmentProviders([
    AxelorSessionHeaderContributor,
    {
      provide: HTTP_HEADER_CONTRIBUTORS,
      useExisting: AxelorSessionHeaderContributor,
      multi: true,
    },
    provideHttpClient(
      withInterceptors([
        csrfTokenInterceptor,
        httpHeadersInterceptor,
        machineInfoInterceptor,
        apiErrorInterceptor,
        requestTimeoutInterceptor,
        testUiMockApiInterceptor,
      ]),
    ),
  ]);
}
